import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MenuItem } from '../../types';
import { classNames } from '../../../../../../helper/classNames';

type MenuItemButtonProps = {
  item: MenuItem;
  isSelected: boolean;
  onClick: React.MouseEventHandler<HTMLElement>;
};

function MenuItemButton({ item, isSelected, onClick }: MenuItemButtonProps) {
  return (
    <>
      <button onClick={onClick} className="block w-full">
        <div
          className={classNames(
            'p-3 flex flex-row justify-start items-center gap-5',
            isSelected ? 'bg-orange-400 text-white' : 'hover:bg-gray-200'
          )}
        >
          {item.icon && <FontAwesomeIcon icon={item.icon} size="lg" />}
          {item.title}
        </div>
      </button>
    </>
  );
}

export default MenuItemButton;
